import { createAsyncThunk } from '@reduxjs/toolkit';
import _orderBy from 'lodash/orderBy';

import { DAILY_CHALLENGE_STRUCTURES } from 'constants/common';

import * as api from 'api/methods';

import * as types from './types';

const _getDailyChallengeModules = async (dailyChallengeId: string) => {
  const promises = [
    api.getCourseModules(dailyChallengeId),
    api.getCourseLessons(dailyChallengeId),
  ];

  const [modules, lessons] = await Promise.all(promises);

  return _orderBy(modules, ['order'], ['asc']).map((module: any) => ({
    ...module,
    lessons: lessons.filter((lesson: any) => lesson.moduleId === module.id),
  }));
};

export const getDailyChallengeForPreview = createAsyncThunk<any, any>(
  types.GET_CURRENT_DAILY_CHALLENGE_PREVIEW,
  async (dailyChallengeId: string) => {
    const dailyChallenge = await api.getDailyChallengeById(dailyChallengeId);

    if (dailyChallenge.structure === DAILY_CHALLENGE_STRUCTURES.MODULES) {
      const modules = await _getDailyChallengeModules(dailyChallengeId);

      return {
        ...dailyChallenge,
        modules,
      };
    }

    if (dailyChallenge.structure === DAILY_CHALLENGE_STRUCTURES.LESSONS) {
      const lessons = await api.getCourseLessons(dailyChallengeId);

      return { ...dailyChallenge, lessons };
    }

    return dailyChallenge;
  },
);
